import { useState } from "react";
import Modal from "react-bootstrap/Modal";

export const InventoryGeneratePublish = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Modal
        className="my_modal"
        show={show}
        onHide={handleClose}
        centered
        size={"lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>제품 검색</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex mb-15px">
            <select className="form-select w-120px">
              <option>대상</option>
            </select>
            <input type="text" className="form-control w-250px ms-5px h-34px" />
            <button
              type="button"
              className="btn btn-info btn_search w-80px ms-5px"
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                alt=""
              />
              조회
            </button>
          </div>
          <table className="table table-bordered my_table table_modal m-0">
            <thead>
              <tr>
                <th style={{ width: "7.1%" }}></th>
                <th style={{ width: "13.66%" }}>벤더</th>
                <th style={{ width: "13.66%" }}>카테고리</th>
                <th style={{ width: "13.66%" }}>품목</th>
                <th style={{ width: "13.66%" }}>규격</th>
                <th style={{ width: "13.66%" }}>대분류</th>
                <th style={{ width: "13.66%" }}>중분류</th>
                <th>환종</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="checkbox_outer">
                    <input className="form-check-input" type="radio" />
                  </div>
                </td>
                <td className="text-center">MS</td>
                <td className="text-center">Compact</td>
                <td className="text-center">S1-WIN…</td>
                <td className="text-center">TNA-00022</td>
                <td className="text-center">OS</td>
                <td className="text-center">Win7</td>
                <td className="text-center">USD</td>
              </tr>
              <tr>
                <td>
                  <div className="checkbox_outer">
                    <input className="form-check-input" type="radio" />
                  </div>
                </td>
                <td className="text-center">MS</td>
                <td className="text-center">Compact</td>
                <td className="text-center">S1-WIN…</td>
                <td className="text-center">TNA-00022</td>
                <td className="text-center">OS</td>
                <td className="text-center">Win7</td>
                <td className="text-center">USD</td>
              </tr>
              <tr>
                <td>
                  <div className="checkbox_outer">
                    <input className="form-check-input" type="radio" />
                  </div>
                </td>
                <td className="text-center">MS</td>
                <td className="text-center">Compact</td>
                <td className="text-center">S1-WIN…</td>
                <td className="text-center">TNA-00022</td>
                <td className="text-center">OS</td>
                <td className="text-center">Win7</td>
                <td className="text-center">USD</td>
              </tr>
              <tr>
                <td>
                  <div className="checkbox_outer">
                    <input className="form-check-input" type="radio" />
                  </div>
                </td>
                <td className="text-center">MS</td>
                <td className="text-center">Compact</td>
                <td className="text-center">S1-WIN…</td>
                <td className="text-center">TNA-00022</td>
                <td className="text-center">OS</td>
                <td className="text-center">Win7</td>
                <td className="text-center">USD</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <button
            type="button"
            className="btn btn-outline-primary w-100px h-38px my-0"
          >
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"
              }
              alt=""
            />
            목록
          </button>
          <button type="button" className="btn btn-dark w-100px h-38px my-0">
            목록
          </button>
        </Modal.Footer>
      </Modal>
      <div className="content_wrap">
        <div className="fiter_top">
          <h3
            className="filter_heading"
            onClick={() => {
              handleShow();
            }}
          >
            출하 상세보기
          </h3>
          <div className="filter_toolbar">
            <button
              type="button"
              className="btn btn-info color3 w-100px h-38px"
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                alt=""
              />
              제품 검색
            </button>
            <button
              type="button"
              className="btn btn-outline-primary w-100px h-38px"
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icon_hamburger_btn.png"
                }
                alt=""
              />
              목록
            </button>
            <button
              type="button"
              className="btn btn-primary w-100px ms-5px h-38px"
            >
              생성
            </button>
          </div>
        </div>
        <h5 className="subheading">제품 정보</h5>
        <table className="table table-bordered my_table table_detail">
          <tbody>
            <tr>
              <th style={{ width: "16.66%" }}>품목명</th>
              <td style={{ width: "33.32%" }}></td>
              <th style={{ width: "16.66%" }}>품목코드</th>
              <td></td>
            </tr>
            <tr>
              <th>벤더</th>
              <td></td>
              <th>대분류</th>
              <td></td>
            </tr>
            <tr>
              <th>카테고리</th>
              <td></td>
              <th>중분류</th>
              <td></td>
            </tr>
            <tr>
              <th>규격</th>
              <td></td>
              <th>사업부별 제품군</th>
              <td></td>
            </tr>
          </tbody>
        </table>
        <h5 className="subheading">가격 정보</h5>
        <table className="table table-bordered my_table">
          <thead>
            <tr>
              <th rowSpan={2}>환종</th>
              <th colSpan={5}>PTA 등급</th>
            </tr>
            <tr>
              <th>Level A</th>
              <th>Level B</th>
              <th>Level C</th>
              <th>Level D</th>
              <th>Level E</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <h5 className="subheading">재고 정보</h5>
        <table className="table table-bordered my_table table_detail">
          <tbody>
            <tr>
              <th style={{ width: "16.66%" }}>단위</th>
              <td style={{ width: "33.32%" }} className="p-4px">
                <input type="text" className="form-control" />
              </td>
              <th style={{ width: "16.66%" }}>안전재고</th>
              <td className="p-4px">
                <input type="text" className="form-control" />
              </td>
            </tr>
            <tr>
              <th>구매가</th>
              <td className="p-4px">
                <input type="text" className="form-control" />
              </td>
              <th>판매가</th>
              <td className="p-4px">
                <input type="text" className="form-control" />
              </td>
            </tr>
            <tr>
              <th>바코드</th>
              <td colSpan={3} className="p-4px">
                <button className="btn btn-dark w-120px h-30px">
                  바코드 생성
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
